import { FC } from 'react';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { Input, Button } from '@forma/forma-ui-kit';
import copyToClipboard from 'helpers/copyToClipboard';
import webView from 'helpers/webview';

import { useAppDispatch } from 'store/hooks';
import { addNotification } from 'store/notifications/notificationsSlice';

import styles from './api-key.module.css';

interface ApiKeyProps {
  apiKey?: string
}

const ApiKey: FC<ApiKeyProps> = ({ apiKey = '' }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleClickCopy = () => {
    const res = copyToClipboard(apiKey);
    if (res === 'success') dispatch(addNotification({ content: t('link_copied'), type: 'SUCCESS' }));
    webView.sendMessage(`openShare ${apiKey}`);
  };

  return (
    <div className={styles.root}>
      <Input
        viewStyle="secondary"
        className={styles.root}
        value={apiKey}
        readOnly
        meta={{
          icon: (
            <Button
              viewStyle="text"
              iconClassName={styles.icon}
              icon={<ReactSVG src="/icons/copy.svg" wrapper="span" />}
              onClick={handleClickCopy}
              title={t('copy')}
            />
          ),
          showIconAlways: true
        }}
      />
    </div>
  );
};

export default ApiKey;
